// extracted by mini-css-extract-plugin
export default {"mainSection":"styles_mainSection__3G04d"};